export default "__VITE_ASSET__BuQw3Pc8__"